import { MenuItem } from "prosemirror-menu";
import type { EditorState } from "prosemirror-state";
import { TextSelection } from "prosemirror-state";
import type { EditorView } from "prosemirror-view";

import { schema } from "../adapter/schema";
import { isFormulaSelected, isSelectionInCodeBlock } from "../utils";

import { TextField, createSelectionElement, openPopoverForm } from "./popover";

import { t } from "i18n/i18n";
import { toolbarFormulaIcon } from "mds/utils/toolbar-icons";

function openFormulaPopoverForm(view: EditorView): void {
  const state = view.state;
  const selectionEl = createSelectionElement(view, state.selection);

  openPopoverForm({
    appendTo: view.dom.closest(".prosemirror-editor-wrapper") as HTMLElement,
    selectionEl,
    title: `${t("worksheet.rich_text_editor.create_formula")}:`,
    onClose: () => view.focus(),
    fields: {
      formula: new TextField({
        name: "formula",
        label: t("worksheet.rich_text_editor.formula_input"),
        placeholder: "e=mc^2",
        required: true,
      }),
    },
    callback(attrs) {
      const currentState = view.state;
      const formulaNode = schema.nodes.formula.create({ formula: String(attrs.formula) });
      const tr = currentState.tr.replaceSelectionWith(formulaNode);

      const pos = tr.doc.resolve(tr.selection.to);
      tr.setSelection(TextSelection.near(pos));

      view.dispatch(tr);
      view.focus();
    },
  });
}

export function formulaItem(): MenuItem {
  return new MenuItem({
    title: t("worksheet.rich_text_editor.create_formula"),
    icon: toolbarFormulaIcon,
    enable(state: EditorState) {
      return !isSelectionInCodeBlock(state) && !isFormulaSelected(state);
    },
    run(_state: EditorState, _dispatch, view: EditorView) {
      openFormulaPopoverForm(view);
    },
  });
}
